<template>
    <div class="wrapper d-flex h-100">
        <Sidebar />
        <div
            id="contents"
            :class="{
                largeHeader,
                'notification-request-bar-active': isNotifyShowing && !isAdmin && !notifyIgnored,
            }"
        >
            <NotificationPermissionAlert
                v-if="isNotifyShowing && !isAdmin && !notifyIgnored"
                @close="isNotifyShowing = false"
            />

            <div class="suspend-notify" v-if="suspend">
                <div>{{ $t("message.suspendedMessage") }}</div>
                <router-link :to="{ name: 'billing' }" style="text-decoration: underline"
                    >{{ $t("message.checkPaymentMethod") }}
                </router-link>
            </div>

            <Header />

            <!-- Main Router View -->
            <router-view />
        </div>
    </div>
</template>

<script>
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { mapState, mapActions } from "vuex";
import NotificationPermissionAlert from "./NotificationPermissionAlert.vue";

export default {
    name: "Layout",
    components: {
        Sidebar,
        Header,
        Footer,
        NotificationPermissionAlert,
    },
    data() {
        return {
            isNotifyShowing: Notification.permission !== "granted",
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            token: (state) => state.auth.token,
            adminUser: (state) => state.auth.adminUser,
            isAdmin: (state) => !!state.auth.adminUser,
            offlineMode: (state) => state.setting.offlineMode,
            suspend: (state) => state.site.site.suspend,
            largeHeader: (state) => state.app.largeHeader,
        }),
        notifyIgnored() {
            return sessionStorage.getItem("dismissed-notify-alert") === "true";
        },
    },
    methods: {
        ...mapActions({
            getUser: "auth/profile",
            getAdminUser: "auth/adminProfile",
        }),
    },
    mounted() {
        if (this.user) {
            this.getUser();
        }

        if (this.adminUser) {
            this.getAdminUser();
        }
    },
};
</script>

<style lang="scss">
.suspend-notify {
    background-color: #ffe027;
    color: #3692ff;
    font-family: "Poppins", "Helvetica Neue", Helvetica, Arial, sans-serif;
    box-sizing: border-box;
    padding: 6px;
    display: flex;
    align-items: center;
    flex-direction: column;
    line-height: initial;
    font-size: 2rem;
}
</style>
